import React from 'react';
import { NavLink } from 'react-router-dom';

import SidebarMenu from '../components/menu/SidebarMenu.component';
import PadLock from '../lib/components/PadLock';

const MENU_ITEMS = [
  { segment: 'buckets', name: 'Reports' },
  { segment: 'dashboard', name: 'Weekly Dashboard' },
  { segment: 'monthly-dashboard', name: 'Monthly Dashboard' },
  { segment: 'services', name: 'Services' },
  { segment: 'kpis', name: 'Staff KPIs' }, // for release 18.09.2024 and check RENDER_TABLE flag
  { segment: 'revenue', name: 'Revenue' },
  { segment: 'future-revenue', name: 'Future Revenue' },
  { segment: 'retail', name: 'Retail' },
  { segment: 'commissions', name: 'Commissions' },
  { segment: 'payments', name: 'Payments' },
  { segment: 'hours', name: 'Hours' },
  { segment: 'bookings', name: 'Bookings' },
  { segment: 'downloadable', name: 'Downloadable' },
];

const ReportsMenu = ({ salonId }) => {
  const linkToReport = ({ salonId, segment }) => `/salon/${salonId}/reports/${segment}`;

  const mapper1 =
    (salonId) =>
    ({ segment, name }) => ({ name, pathname: linkToReport({ salonId, segment }) });
  const mapper2 = ({ pathname, name }, index) => ({ id: index + 1, name, to: { pathname } });

  const menuItemLink = MENU_ITEMS.map(mapper1(salonId))
    .map((item, index) => mapper2(item, index))
    .map(({ id, name, to }) => (
      <li key={id}>
        <NavLink to={to} className="label-menu-btn" activeClassName="selected">
          {name}
        </NavLink>
      </li>
    ));

  return (
    <header className="settings-header stock-global-nav">
      <SidebarMenu />
      <div className="global-nav">
        <div className="page-name text-mobile reports" />
        <nav className="menu-list">
          <ul className="ul-scroll-menu">{menuItemLink}</ul>
        </nav>
      </div>
      <PadLock />
    </header>
  );
};

export default ReportsMenu;
